export const IMAGE = 'image';
export const TEXT = 'text';
export const DOODLE = 'doodle';
export const CARD = 'card';
export const LOGO = 'logo';
export const CLIPART = 'clipart';
export const SIGNATURE = 'Signature';
export const FILTERS = 'filters';
export const OVERLAY = 'overlay'
export const MONOGRAM = 'monogram'
export const STOCK_IMAGE = 'StockImageLayer';
export const CUSTOM_IMAGE = 'CustomImageLayer';
